export interface Template {
  id: string;
  name: string;
  description: string;
  category: string;
  prompt: string;
  isPremium: boolean;
  thumbnail?: string;
  backgroundImage?: string;
  colorPalette?: {
    primary: string;
    secondary: string;
    accent?: string;
  };
}

export interface TemplateCategory {
  id: string;
  name: string;
  description: string;
  templates: Template[];
}

export const TEMPLATE_CATEGORIES: TemplateCategory[] = [
  {
    id: 'business',
    name: 'ビジネス',
    description: 'ビジネス向けのオーソドックスなテンプレート',
    templates: [
      {
        id: 'studio_white',
        name: 'スタジオ（ホワイト）',
        description: '清潔感のある白いスタジオ背景',
        category: 'business',
        prompt: 'プロフェッショナルな白いスタジオ背景、清潔感のある照明',
        isPremium: false,
        backgroundImage: 'studio-white'
      },
      {
        id: 'studio_gray',
        name: 'スタジオ（グレー）',
        description: '落ち着いたグレーのスタジオ背景',
        category: 'business',
        prompt: 'プロフェッショナルなグレーのスタジオ背景、上品な照明',
        isPremium: false,
        backgroundImage: 'studio-gray'
      },
      {
        id: 'studio_dark_gray',
        name: 'スタジオ（ダークグレー）',
        description: '落ち着いたダークグレーのスタジオ背景',
        category: 'business',
        prompt: 'プロフェッショナルなダークグレーのスタジオ背景、洗練された照明',
        isPremium: false,
        backgroundImage: 'studio-dark-gray'
      },
      {
        id: 'studio_light_purple',
        name: 'スタジオ（ライトパープル）',
        description: '上品なライトパープルのスタジオ背景',
        category: 'business',
        prompt: 'プロフェッショナルなライトパープルのスタジオ背景、洗練された照明',
        isPremium: false,
        backgroundImage: 'studio-light-purple'
      },
      {
        id: 'studio_light_pink',
        name: 'スタジオ（ライトピンク）',
        description: '優しいライトピンクのスタジオ背景',
        category: 'business',
        prompt: 'プロフェッショナルなライトピンクのスタジオ背景、温かみのある照明',
        isPremium: false,
        backgroundImage: 'studio-light-pink'
      },
      {
        id: 'studio_light_blue',
        name: 'スタジオ（ライトブルー）',
        description: '爽やかなライトブルーのスタジオ背景',
        category: 'business',
        prompt: 'プロフェッショナルなライトブルーのスタジオ背景、清々しい照明',
        isPremium: false,
        backgroundImage: 'studio-light-blue'
      }
    ]
  },
  {
    id: 'creative',
    name: 'クリエイティブ',
    description: 'クリエイティブな業界向けのテンプレート',
    templates: [
      {
        id: 'white_wood',
        name: '白の木目',
        description: 'ナチュラルで上品な白い木目調',
        category: 'creative',
        prompt: '白い木目調の背景、ナチュラルで上品な仕上がり',
        isPremium: false,
        backgroundImage: 'white-wood'
      },
      {
        id: 'salon_interior',
        name: '美容室',
        description: 'プロフェッショナルな美容室の雰囲気',
        category: 'creative',
        prompt: '美容室の内装を背景に、プロフェッショナルな仕上がり',
        isPremium: false,
        backgroundImage: 'salon-interior'
      },
      {
        id: 'cafe_cozy',
        name: '落ち着いたカフェ',
        description: '温かみのあるカフェの雰囲気',
        category: 'creative',
        prompt: '落ち着いたカフェの内装を背景に、温かみのある仕上がり',
        isPremium: false,
        backgroundImage: 'cafe-cozy'
      },
      {
        id: 'concert_hall',
        name: 'コンサートホール',
        description: '華やかなコンサートホールの雰囲気',
        category: 'creative',
        prompt: 'コンサートホールの舞台を背景に、華やかな仕上がり',
        isPremium: false,
        backgroundImage: 'concert-hall'
      },
      {
        id: 'beach_sunset',
        name: 'ビーチ・夕焼け',
        description: 'ロマンチックなビーチの夕焼け',
        category: 'creative',
        prompt: 'ビーチの夕焼けを背景に、ロマンチックな仕上がり',
        isPremium: false,
        backgroundImage: 'beach-sunset'
      },
      {
        id: 'urban_street',
        name: '都会の街並み',
        description: 'モダンな都市の雰囲気',
        category: 'creative',
        prompt: '都会の街並みを背景に、モダンで洗練された仕上がり',
        isPremium: false,
        backgroundImage: 'urban-street'
      },
      {
        id: 'balloons',
        name: '風船の背景',
        description: '風船で溢れかえっている背景',
        category: 'creative',
        prompt: '風船で溢れかえっている背景、明るく華やかな雰囲気',
        isPremium: false,
        backgroundImage: 'balloons'
      }
    ]
  },
  {
    id: 'custom',
    name: 'カスタム',
    description: 'カスタムテンプレート',
    templates: [
      {
        id: 'custom_template',
        name: 'その他（テキストで指定）',
        description: 'カスタムテンプレート',
        category: 'custom',
        prompt: '',
        isPremium: false,
        backgroundImage: 'background-custom-text'
      },
      {
        id: 'custom_image',
        name: '⭐️その他（写真を添付する）',
        description: 'オリジナル背景を添付',
        category: 'custom',
        prompt: '',
        isPremium: true,
        backgroundImage: 'background-custom-image'
      }
    ]
  }
];

// 全てのテンプレートを取得する関数
export const getAllTemplates = (): Template[] => {
  return TEMPLATE_CATEGORIES.flatMap(category => category.templates);
};

// カテゴリ別にテンプレートを取得する関数
export const getTemplatesByCategory = (categoryId: string): Template[] => {
  const category = TEMPLATE_CATEGORIES.find(cat => cat.id === categoryId);
  return category ? category.templates : [];
};

// テンプレートIDでテンプレートを取得する関数
export const getTemplateById = (templateId: string): Template | undefined => {
  return getAllTemplates().find(template => template.id === templateId);
};
